<div class="main-container">
    <app-loader [isLoading]="loading"></app-loader>
    <div class="confirmation-container">
      <div *ngIf="businessDetails?.businessLogo" class="header-section">
        <div class="logo-container d-flex">
          <img class="logo" [src]="businessDetails?.businessLogo">
        </div>
      </div>
        <div class="wbg">
          <div class="row m-0 mt-3">
            <div class="center-logo">
              <img src="assets/images/booking-success.svg">
            </div>
          </div>
          <div class="row m-0 mt-3">
            <label class="success-text" *ngIf="!isInquiry">Successfully booked an appointment</label>
            <label class="success-text" *ngIf="isInquiry">We have received your Enquiry</label>
          </div>
          <div class="row m-0 mt-1">
            <label class="company-name">with {{businessDetails.businessName}}</label>
          </div>

          <div class="center-block mt-5" *ngIf="!isInquiry">
            <label class="success-text">Your Appointment Details</label>
            <div class="row m-0 mt-3">
              <label class="appointment-label">Appointment ID</label>
              <label class="appointment-value">{{appointmentData.bookingId}}</label>
            </div>
            <div class="row m-0">
              <label class="appointment-label">Date</label>
              <label class="appointment-value">{{appointmentData.bookingDate}}</label>
            </div>
            <div class="row m-0">
              <label class="appointment-label">Time Slot</label>
              <label class="appointment-value">{{show12HrTime(appointmentData.bookingTime)}}</label>
            </div>
            <div class="row m-0" *ngIf="appointmentData.email">
              <label class="appointment-label">Email ID</label>
              <label class="appointment-value">{{appointmentData.email }}</label>
            </div>
            <div class="row m-0" *ngIf="appointmentData?.categoryName">
              <label class="appointment-label">Category</label>
              <label class="appointment-value">{{appointmentData?.categoryName}}</label>
            </div>
            <div class="row m-0" *ngIf="appointmentData.personnelValue">
              <label class="appointment-label">{{appointmentData.personnelKey}}</label>
              <label class="appointment-value">{{appointmentData.personnelValue}}</label>
            </div>
          </div>

          <div class="center-block mt-5" *ngIf="isInquiry">
            <label class="success-text">Your Enquiry Details</label>
            <div class="row m-0 mt-3">
              <label class="appointment-label">Enquiry ID</label>
              <label class="appointment-value">{{appointmentData.bookingId}}</label>
            </div>
            <div class="row m-0">
              <label class="appointment-label">Name</label>
              <label class="appointment-value">{{appointmentData.name}}</label>
            </div>
            <div class="row m-0">
              <label class="appointment-label">Phone Number</label>
              <label class="appointment-value">{{appointmentData.phone}}</label>
            </div>
            <div class="row m-0" *ngIf="appointmentData.email">
              <label class="appointment-label">Email ID</label>
              <label class="appointment-value">{{appointmentData.email }}</label>
            </div>
            <div class="row m-0" *ngIf="appointmentData?.categoryName">
              <label class="appointment-label">Category</label>
              <label class="appointment-value">{{appointmentData?.categoryName}}</label>
            </div>
            <div class="row m-0" *ngIf="appointmentData.personnelValue">
              <label class="appointment-label">{{appointmentData.personnelKey}}</label>
              <label class="appointment-value">{{appointmentData.personnelValue}}</label>
            </div>
          </div>

          <div class="row m-0 mt-3 my-3" *ngIf="businessDetails.confirmationText">
            <label class="banner-text">{{businessDetails.confirmationText}}</label>
          </div>

          <div class="row m-0 my-4">
            <button *ngIf="!isInquiry" class='btn-nxt' (click)="navigateToMainPage()">Book another appointment</button>
            <button *ngIf="isInquiry" class='btn-nxt' (click)="navigateToMainPage()">Close</button>
          </div>

        </div>
    </div>

    <div>
        <app-footer-powered-by-image></app-footer-powered-by-image>
    </div>

</div>
